import styled, { css } from 'styled-components';
import { MilestoneStatusCode } from '@bechtel/types';
import { Box, ButtonStyled, Button } from '@bechtel/gds';
import { Link, LinkProps } from 'react-router-dom';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import blockedPattern from '@bechtel/client-assets/dist/images/pattern-red.svg';
import { ActivityIconPatternProps } from './types';

function getPatternColor(props: ActivityIconPatternProps) {
  switch (props.status) {
    case MilestoneStatusCode.CANCELED:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[100]};
      `;
    case MilestoneStatusCode.REQUESTED:
      return css`
        background-color: ${({ theme }) => theme.colors.yellow[300]};
      `;
    case MilestoneStatusCode.APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case MilestoneStatusCode.CLAIMED:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
      `;
    case MilestoneStatusCode.REJECTED:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[500]};
      `;
    case MilestoneStatusCode.BLOCKED:
      return css`
        background-color: ${({ theme }) => theme.colors.red[400]};
        background-image: url(${blockedPattern});
        background-repeat: repeat;
        background-size: ${({ theme }) => theme.fontSizes[500]};
      `;
    case MilestoneStatusCode.UNPLANNED:
      return css`
        background-color: ${({ theme }) => theme.colors.grey[500]};
      `;

    case MilestoneStatusCode.UNCLAIMED:
    default:
      return css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
  }
}
export const FinalActivity = styled.div`
  width: 10px;
  height: 10px;
  background: ${({ theme }) => theme.colors.bechtel.blue[700]};
  border-radius: ${({ theme }) => theme.radii[900]};
`;

export const ActivityIconPattern = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme.colors.bechtel.blue[800]};
  border-radius: ${({ theme }) => theme.radii[900]};
  ${getPatternColor}
`;

export const ButtonLink = styled(ButtonStyled).attrs({
  as: Link,
})<LinkProps>``;

export const CommentStyled = styled(Box).attrs({
  p: { sm: '450' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.radii[400]};
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[600]};
    margin-top: -${theme.spacings[200]};
    font-family: ${theme.fontFamilies['graphik']};
  `}
`;

export const PipeCleaninessStyled = styled(Box).attrs({
  p: { sm: '400' },
  justifyContent: { sm: 'space-between' },
  mt: { sm: '100' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.green[100]};
    border-radius: ${theme.radii[400]};
  `}
`;

export const ArrowStyled = styled(Box).attrs({ ml: { sm: '400' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    width: 9px;
    height: 9px;
    transform: rotate(-135deg);
  `}
`;

export const ReasonAlignmentStyled = styled(Box)`
  width: 178px;
  word-break: keep-all;
  line-height: normal;
`;

export const AttachmentButton = styled(Button)`
  ${({ theme }) =>
    css`
      width: auto;
      margin-left: ${theme.spacings['400']};
      padding: ${theme.spacings['100']};
    `}
`;
export const AttachmentsCountStyled = styled(Box)`
  ${({ theme }) =>
    css`
      width: ${theme.spacings['500']};
      height: ${theme.spacings['500']};
      border: solid 1px ${theme.colors.white};
      background-color: ${theme.colors.bechtel.red};
      color: ${theme.colors.white};
      position: relative;
      top: -${theme.spacings['300']};
      left: ${theme.spacings['800']};
      border-radius: ${theme.radii['900']};
      font-size: ${theme.fontSizes['300']};
    `}
`;
